<template>
  <div class="primary-container">
    <el-table :data="lowsourceInfo.result"
              style="width: 100%"
              height="100%">
      <el-table-column class-name="number"
                       label="序号"
                       align="center"
                       type="index"
                       min-width="50"
                       fixed>
      </el-table-column>
      <el-table-column class-name="sourceNumber"
                       prop="cargoId"
                       label="货源编号"
                       min-width="100"
                       header-align="center"
                       align="center">
      </el-table-column>
      <el-table-column header-align="center"
                       align="center"
                       label="公司名称"
                       min-width="120">
        <template slot-scope="scope">
          <div>{{scope.row.companyName}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="companyPhone"
                       label="公司电话"
                       header-align="center"
                       align="center"
                       width="106">
      </el-table-column>
      <el-table-column label="出发地"
                       header-align="center"
                       align="center"
                       min-width="120">
        <template slot-scope="scope">
          <div>{{scope.row.startingAddressName}}</div>
        </template>
      </el-table-column>
      <el-table-column label="目的地"
                       header-align="center"
                       align="center"
                       min-width="130">
        <template slot-scope="scope">
          <div>{{scope.row.endAddressName}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="goodsName"
                       label="原料"
                       header-align="center"
                       align="center"
                       width="100">
      </el-table-column>
      <el-table-column header-align="center"
                       prop="createDate"
                       label="发布时间"
                       width="90"
                       align="center"></el-table-column>
      <el-table-column prop="remark"
                       label="备注"
                       header-align="center"
                       align="center"
                       min-width="100"></el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{lowsourceInfo.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="lowsourceInfo.pageSize"
                     layout="prev, pager, next"
                     :total="lowsourceInfo.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { lowSource } from 'apis/index'
import { mapState } from 'vuex'
import Bus from '../../Bus.js'
export default {
  name: 'Container',
  data () {
    return {
      searchInfo: {}
    }
  },
  computed: mapState({
    lowsourceInfo: state => state.lowsource.lowsourceInfo
  }),
  mounted () {
    this.getSourceData()
    Bus.$on('getSearchInfo', res => {
      this.searchInfo = res
    })
  },
  methods: {
    getSourceData () { // 获取信息
      lowSource().then(res => {
        if (res.data.code === 0) {
          let lowsourceInfo = res.data.data.pagination
          this.$store.commit('lowsource/updateData', lowsourceInfo)
        }
      })
    },

    handleCurrentChange (val) { // 切页切换
      let pageNum = val

      lowSource({
        pageNum: pageNum,
        companyName: this.searchInfo.companyName,
        startingAddressName: this.searchInfo.startingAddressName,
        endAddressName: this.searchInfo.endAddressName
      }).then(res => {
        let lowsourceInfo = res.data.data.pagination
        this.$store.commit('lowsource/updateData', lowsourceInfo)
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.primary-container
  height calc(100% - 100px)
  .el-table
    background #f7f9fb
    .el-table__header
      th
        width 100%
        background #e7f0f8
      .cell
        line-height 25px
    td
      .cell
        font-size 12px
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  pages()
</style>
